import React, { useState, useEffect, useRef } from "react";
import DatosMovimientoAlmacen from "./DatosMovimientoAlmacenIngreso";
import { notificarError, notificarMsg } from "../Almacenes/AlmacenNotify";
import moment from "moment";
import { GastosSelector } from "./GastosSelector";
import { GUIA_REMISION, NOTA_INGRESO, FACTURA, BOLETA, SOLES_A_CENTIMOS } from "../../Global";
import { OrdenesCompraSelector } from "./ComprasExternasSelector";
import { NotasEgresoSelector } from "./NotasEgresoSelector";
import ModalProveedor from "../clientes/ClienteModal";
import ProveedorNuevo from "../Proveedores/ProveedorNuevo";
import ProveedorSearch from "../Proveedores/ProveedoresListaSearch";

export default function RegistrarMovimientoAlmacen({ idAlmacen, onRegistroCompletado, onCancel, compraDelaSunat = null, skipSunatValidation = false }) {
    const [proveedor, setProveedor] = useState(null);
    const [linkedDocument, setLinkedDocument] = useState(null);
    const [gastos, setGastos] = useState([]);
    const [ordenesCompra, setOrdenesCompra] = useState([]);
    const [notasEgreso, setNotasEgreso] = useState([]);
    const [gastoSeleccionado, setGastoSeleccionado] = useState(null);
    const [ordenCompraSeleccionada, setOrdenCompraSeleccionada] = useState(null);
    const [notaEgresoSeleccionada, setNotaEgresoSeleccionada] = useState(null);
    const [modalProveedorIsOpen, setModalProveedorIsOpen] = useState(false);
    const [accionProveedor, setAccionProveedor] = useState(null);
    const [rucProveedor, setRucProveedor] = useState("");
    const [glosa, setGlosa] = useState("");
    const [confEmpresa, setConfEmpresa] = useState({
        deactivateValidationOnAmountOnMovAlmacen: false
    });
    const [listaProveedores, setListaProveedores] = useState([]);
    
    const formProveedorRef = useRef({
        IdProveedor: null,
        Ruc: "",
        NomProveedor: "",
        NomContacto: ""
    });

    useEffect(() => {
        fetchGastos();
        fetchComprasExternas();
        fetchNotasEgreso();
        fetchConfEmpresa();
        cargarProveedores();
    }, []);

    useEffect(() => {
        if (compraDelaSunat && listaProveedores.length > 0) {
            autocompletarConCompra(compraDelaSunat);
        }
    }, [listaProveedores]);
    const autocompletarConCompra = (compra) => {
        try {
            const rucBuscado = String(compra.ruc_proveedor || "").trim();

            const proveedorEncontrado = listaProveedores.find(p => {
                const rucsDelProveedor = [
                    String(p.Ruc || "").trim(),
                    String(p.ruc || "").trim(),
                    String(p.RUC || "").trim(),
                    String(p.NumDocumento || "").trim(),
                    String(p.numdocumento || "").trim(),
                ];
                return rucsDelProveedor.includes(rucBuscado);
            });

            if (!proveedorEncontrado) {
                notificarError(`Proveedor con RUC ${rucBuscado} no encontrado. Debe seleccionar uno manualmente.`);
                return;
            }

            const proveedorFormato = {
                IdProveedor: proveedorEncontrado.IdProveedor,
                Ruc: proveedorEncontrado.Ruc || compra.ruc_proveedor,
                NombreComercial: proveedorEncontrado.NombreComercial || proveedorEncontrado.NomProveedor || compra.razon_social,
                value: `${proveedorEncontrado.IdProveedor}-${proveedorEncontrado.Ruc || compra.ruc_proveedor}`,
                label: proveedorEncontrado.NombreComercial || proveedorEncontrado.NomProveedor || compra.razon_social
            };

            const mapaTipoDoc = {
                "01": FACTURA,
                "03": BOLETA,
            };
            const tipoDocMapeado = mapaTipoDoc[compra.tipo_doc] || FACTURA;
            
            const linkedDocFormato = {
                tipoDoc: tipoDocMapeado,
                serie: compra.serie || "",
                correlativo: String(compra.numero || "").trim(),
                total: Number(compra.total || 0),
                montoImporteVenta: Number(compra.total || 0),
                fechaEmision: compra.fecha_emision || moment().format("YYYY-MM-DD"),
                fechaMovimiento: compra.fecha_emision || moment().format("YYYY-MM-DD"),
            };

            const tipoDocDesc = compra.tipo_doc_descripcion || "Documento";
            const glosaGenerada = `Compra según SUNAT - ${tipoDocDesc} ${compra.serie}-${compra.numero} de ${compra.razon_social}`;

            setProveedor(proveedorFormato);
            setLinkedDocument(linkedDocFormato);
            setGlosa(glosaGenerada);
            setRucProveedor(proveedorFormato.Ruc);

            notificarMsg("Datos precargados desde SUNAT SIRE", "success");
        } catch (error) {
            console.error("Error autocompletando:", error);
            notificarError("Error al autocompletar datos de SUNAT");
        }
    };

    const cargarProveedores = async () => {
        try {
            const response = await fetch('/api/proveedores/list/');
            const data = await response.json();
            const proveedoresData = data[1] || [];
            setListaProveedores(proveedoresData);
        } catch (error) {
            console.error("Error cargando proveedores:", error);
        }
    }

    const fetchConfEmpresa = async () => {
        const req = await fetch(`/api/config/emp`);
        const conf = await req.json();

        if (!('deactivateValidationOnAmountOnMovAlmacen' in conf)) {
            conf['deactivateValidationOnAmountOnMovAlmacen'] = false;
        };

        setConfEmpresa(conf);
    }

    const fetchGastos = async () => {
        const startDate = moment().subtract(3, 'days').format("YYYY-MM-DD");
        const endDate = moment(new Date()).format("YYYY-MM-DD");
    
        const response = await fetch(`/api/comprasexternas/items?almacen=${idAlmacen}&desde=${startDate}&hasta=${endDate}`);

        if (!response.ok) {
            notificarError("No se pudo obtener los gastos.");
            return;
        }

        const data = await response.json();

        setGastos(data.items);
    }

    const fetchComprasExternas = async () => {
        const response = await fetch(`/api/ordenescompra/list/allsuc/poratender`);

        if (!response.ok) {
            notificarError("No se pudo obtener las compras externas.");
            return;
        }

        const data = await response.json();

        setOrdenesCompra(data[1]);
    }

    const fetchNotasEgreso = async () => {
        const response = await fetch(`/api/movimientosalmacen/notas-egreso/list/allsuc/poratender`);

        if (!response.ok) {
            notificarError("No se pudo obtener las notas de egreso.");
            return;
        }

        const data = await response.json();

        setNotasEgreso(data);
    }

    const handleChangeProveedor = (proveedor) => {
        setProveedor(proveedor);
    }

    const handleClickNuevoProveedor = () => {
        setModalProveedorIsOpen(true);
        setAccionProveedor('NuevoProveedor');
    }

    const handleClickBuscarProveedor = () => {
        formProveedorRef.current = {
            IdProveedor: proveedor?.IdProveedor || null,
            Ruc: proveedor?.Ruc || "",
            NomProveedor: proveedor?.NombreComercial || "",
            NomContacto: ""
        };
        setModalProveedorIsOpen(true);
        setAccionProveedor('BuscarProveedor');
    }

    const handleCloseModalProv = () => {
        if (formProveedorRef.current.IdProveedor && formProveedorRef.current.Ruc) {
            const proveedorActualizado = {
                IdProveedor: formProveedorRef.current.IdProveedor,
                Ruc: formProveedorRef.current.Ruc,
                NombreComercial: formProveedorRef.current.NomProveedor,
                value: `${formProveedorRef.current.IdProveedor}-${formProveedorRef.current.Ruc}`,
                label: formProveedorRef.current.NomProveedor
            };
            setProveedor(proveedorActualizado);
        }
        setModalProveedorIsOpen(false);
    }

    const AsignarValorDoc = (dataProveedor) => {
        const nuevoProveedor = {
            IdProveedor: dataProveedor.IdProveedor,
            Ruc: dataProveedor.Ruc,
            NombreComercial: dataProveedor.RazonSocial,
            value: `${dataProveedor.IdProveedor}-${dataProveedor.Ruc}`,
            label: dataProveedor.RazonSocial
        };
        setProveedor(nuevoProveedor);
        setRucProveedor(dataProveedor.Ruc);
        formProveedorRef.current = {
            IdProveedor: dataProveedor.IdProveedor,
            Ruc: dataProveedor.Ruc,
            NomProveedor: dataProveedor.RazonSocial,
            NomContacto: dataProveedor.Contacto || ""
        };
    }

    const onChangeLinkedDocument = (linkedDocument) => {
        setLinkedDocument(linkedDocument);
    }

    const validateNotaIngreso = async () => {
        guardarMovimiento();
    }

    const validateGuiaRemision = async () => {
        const { serie, correlativo, fechaMovimiento } = linkedDocument;

        const serieValida = serie && serie.trim().length > 0;
        const correlativoValido = correlativo.trim() && /^\d+$/.test(correlativo);
        const fechaMovimientoValida = fechaMovimiento && moment(fechaMovimiento).isValid();

        if (!serieValida) {
            notificarError("La serie es requerida.");
            return;
        }

        if (!correlativoValido) {
            notificarError("El correlativo es requerido.");
            return;
        }

        if (!fechaMovimientoValida) {
            notificarError("La fecha de emisión es requerida.");
            return;
        }

        guardarMovimiento();
    }

    const validateComprobante = async () => {
        const { serie, correlativo, tipoDoc, total: montoImporteVenta, fechaMovimiento } = linkedDocument;

        const serieValida = serie && serie.trim().length > 0;
        const correlativoValido = correlativo.trim() && /^\d+$/.test(correlativo);
        const totalValido = montoImporteVenta && /^\d*\.?\d*$/.test(montoImporteVenta);
        const fechaMovimientoValida = fechaMovimiento && moment(fechaMovimiento).isValid();

        if (!serieValida) {
            notificarError("La serie es requerida.");
            return;
        }

        if (!correlativoValido) {
            notificarError("El correlativo es requerido.");
            return;
        }

        if (!confEmpresa.deactivateValidationOnAmountOnMovAlmacen && !totalValido) {
            notificarError("El monto es requerido.");
            return;
        }

        if (!fechaMovimientoValida) {
            notificarError("La fecha de emisión es requerida.");
            return;
        }

        try {
            const response = await fetch(`/api/movimientosalmacen/validar-comprobante`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify({
                    consultaComprobante: {
                        numDoc: proveedor.Ruc,
                        serie,
                        correlativo,
                        tipoDoc,
                        montoImporteVenta,
                        fechaEmision: fechaMovimiento,
                    },
                }),
            });

            if (response.status === 200) {
                notificarMsg("El comprobante es válido.");
                guardarMovimiento();
            } else {
                notificarError("El comprobante no es válido o hubo un error al validar.");
                if (window.confirm("¿Desea continuar de todas maneras?")) {
                    guardarMovimiento();
                }
            }
        } catch (error) {
            notificarError(error.message);
        }
    }

    const handleValidarComprobante = async () => {
        if (!proveedor) {
            notificarError("El campo proveedor es requerido.");
            return;
        }

        if (!linkedDocument) {
            notificarError("Se debe asociar un comprobante válido.");
            return;
        }
        
        const { tipoDoc } = linkedDocument;


        if (skipSunatValidation) {
            notificarMsg("Comprobante válido (validado desde SUNAT SIRE).");
            guardarMovimiento();
            return;
        }

        if (+tipoDoc === NOTA_INGRESO) {
            await validateNotaIngreso();
        } else if (+tipoDoc === GUIA_REMISION) {
            await validateGuiaRemision();
        } else {
            await validateComprobante();
        }
    }

    const handleSeleccionarGasto = (gasto) => {
        setGastoSeleccionado(gasto.IdCompraExterna);
    }

    const handleSeleccionarCompraExterna = (compraExterna) => {
        setOrdenCompraSeleccionada(compraExterna.IdOrdenCompra);
    }

    const handleSeleccionarNotaEgreso = (notaEgreso) => {
        setNotaEgresoSeleccionada(notaEgreso.IdMovimientoAlmacen);
    }

    const guardarMovimiento = async () => {
        const totalMovimiento = confEmpresa.deactivateValidationOnAmountOnMovAlmacen 
            ? 0 
            : +linkedDocument.total;
        
        const req = await fetch("/api/movimientosalmacen/add/", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                IdMovimientoAlmacen: 1,
                Numero: "",
                FechaRegistro: moment(new Date()).format("YYYY-MM-DD HH:mm"),
                FechaMovimiento: moment(linkedDocument.fechaEmision).format("YYYY-MM-DD HH:mm"),
                IdAlmacen: idAlmacen,
                IdTipoDocumentoSunat: linkedDocument.tipoDoc,
                NroDocumentoSunat: `${linkedDocument.serie}-${linkedDocument.correlativo}`,
                DocInterno: "",
                IdOrdenCompra: ordenCompraSeleccionada,
                IdCompraExterna: gastoSeleccionado,
                IdNotaEgreso: notaEgresoSeleccionada,
                NroOrdenCompra: "",
                Estado: "Sin procesar",
                IdProveedor: proveedor.IdProveedor,
                tipoCambio: 0,
                idCce: null,
                idTipoMov: 1,
                total: Math.round(Number(totalMovimiento) * SOLES_A_CENTIMOS),
                Glosa: glosa,
            })
        });

        const rpta = await req.json();

        // Desglosar validaciones para obtener mensajes más específicos
        try {
            // Validación 0: Verificar si es una respuesta de error (objeto con propiedad respuesta)
            if (typeof rpta === 'object' && rpta !== null && !Array.isArray(rpta) && rpta.respuesta) {
                console.warn("⚠️ Validación del servidor: ", rpta.respuesta);
                notificarError(rpta.respuesta);
                return;
            }

            // Validación 1: Verificar si la respuesta es un array
            if (!Array.isArray(rpta)) {
                console.error("❌ Error estructura 1: La respuesta no es un array. Recibido:", typeof rpta, rpta);
                notificarError("Error: La respuesta del servidor no tiene el formato esperado (no es array).");
                return;
            }

            // Validación 2: Verificar si el array tiene elementos
            if (rpta.length === 0) {
                console.error("❌ Error estructura 2: El array está vacío.");
                notificarError("Error: El servidor devolvió una respuesta vacía.");
                return;
            }

            // Validación 3: Verificar si rpta[0] es un array
            if (!Array.isArray(rpta[0])) {
                console.error("❌ Error estructura 3: rpta[0] no es un array. Recibido:", typeof rpta[0], rpta[0]);
                notificarError("Error: La estructura de datos no es válida en el nivel 1.");
                return;
            }

            // Validación 4: Verificar si rpta[0] tiene elementos
            if (rpta[0].length === 0) {
                console.error("❌ Error estructura 4: rpta[0] está vacío.");
                notificarError("Error: No se recibieron datos de movimiento.");
                return;
            }

            // Validación 5: Verificar si rpta[0][0] es un array
            if (!Array.isArray(rpta[0][0])) {
                console.error("❌ Error estructura 5: rpta[0][0] no es un array. Recibido:", typeof rpta[0][0], rpta[0][0]);
                notificarError("Error: La estructura de datos no es válida en el nivel 2.");
                return;
            }

            // Validación 6: Verificar si rpta[0][0] tiene elementos
            if (rpta[0][0].length === 0) {
                console.error("❌ Error estructura 6: rpta[0][0] está vacío.");
                notificarError("Error: No se encontraron resultados de validación.");
                return;
            }

            // Validación 7: Verificar si rpta[0][0][0] existe
            if (!rpta[0][0][0]) {
                console.error("❌ Error estructura 7: rpta[0][0][0] no existe.");
                notificarError("Error: No hay datos en la respuesta del servidor.");
                return;
            }

            // Validación 8: Verificar si rpta[0][0][0].estado existe
            if (!rpta[0][0][0].estado) {
                console.error("❌ Error estructura 8: La propiedad 'estado' no existe en rpta[0][0][0].", rpta[0][0][0]);
                notificarError("Error: El servidor no devolvió el ID del movimiento registrado.");
                return;
            }

            // Validación 9: Verificar si estado es un valor válido
            const movimientoId = rpta[0][0][0].estado;
            if (!movimientoId || isNaN(+movimientoId)) {
                console.error("❌ Error estructura 9: El 'estado' no es un número válido. Recibido:", movimientoId);
                notificarError("Error: El ID del movimiento no es válido.");
                return;
            }

            onRegistroCompletado(+movimientoId);

        } catch (error) {
            console.error("❌ Error inesperado al procesar la respuesta:", error.message);
            notificarError(`Error inesperado: ${error.message}`);
        }
    }

    return <div className="container-fluid" style={{ width: '100%' }}>
        <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link active" id="nav-info-tab" data-toggle="tab" data-target="#nav-info" type="button" role="tab" aria-controls="nav-info" aria-selected="true">Datos de movimiento</button>
                <button className="nav-link text-muted" id="nav-items-tab" data-toggle="tab" data-target="#nav-items" type="button" role="tab" aria-controls="nav-items" aria-selected="false" disabled>Items</button>
            </div>
        </nav>

        <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade show active" id="nav-info" role="tabpanel" aria-labelledby="nav-info-tab">
                <div className="row">
                    <div className="col-12">
                        <DatosMovimientoAlmacen
                            proveedor={proveedor}
                            handleChangeProveedor={handleChangeProveedor}
                            onChangeLinkedDocument={onChangeLinkedDocument}
                            handleClickNuevoProveedor={handleClickNuevoProveedor}
                            handleClickBuscarProveedor={handleClickBuscarProveedor}
                            linkedDocument={linkedDocument}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Asociar con orden de compra</label>
                        <OrdenesCompraSelector options={ordenesCompra} onSeleccionChange={handleSeleccionarCompraExterna} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Asociar con nota de egreso</label>
                        <NotasEgresoSelector options={notasEgreso} onSeleccionChange={handleSeleccionarNotaEgreso} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Asociar con gasto de flete</label>
                        <GastosSelector options={gastos} onSeleccionChange={handleSeleccionarGasto} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Glosa</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            value={glosa}
                            onChange={(e) => setGlosa(e.target.value)}
                            placeholder="Ingrese observaciones"
                        />
                    </div>
                </div>
            </div>
            <div className="tab-pane fade" id="nav-items" role="tabpanel" aria-labelledby="nav-items-tab">
            </div>
        </div>

        <div className="d-flex justify-content-between">
            <button type="button" className="btn btn-danger" onClick={onCancel}>Cancelar</button>
            <button type="button" className="btn btn-info" onClick={handleValidarComprobante}>Validar movimiento</button>
        </div>

        {
            accionProveedor === 'NuevoProveedor' ?
                <ModalProveedor 
                    isOpen={modalProveedorIsOpen}
                    onClose={handleCloseModalProv}
                    title="NUEVO PROVEEDOR"
                >
                    <ProveedorNuevo
                        onClose={handleCloseModalProv}
                        NumeroDocumento={rucProveedor}
                        AsignarValorDoc={AsignarValorDoc}
                        sw='oc_nuevo'
                    />
                </ModalProveedor> :
                <ModalProveedor 
                    isOpen={modalProveedorIsOpen}
                    onClose={handleCloseModalProv}
                    title="BUSCAR PROVEEDOR"
                >
                    <ProveedorSearch
                        onClose={handleCloseModalProv}
                        form={formProveedorRef.current}
                    />
                </ModalProveedor>
        }
    </div>
}